import * as React from 'react';
import Listing from './listing';
import ListingCard from './listing_card';

import Tiles from '@reverbdotcom/commons/dist/components/tiles';

interface Props {
  listings: Listing[];
  showSearchFooter?: boolean;
  pagination?: React.ReactNode;
  heading?: boolean;
  actions?: JSX.Element[];
  children?: React.ReactNode;
  trackName?: string;
  trackContext?: object;
}

export default class GridView extends React.Component<Props, null> {
  static defaultProps: Partial<Props> = {
    showSearchFooter: false,
    pagination: false,
    heading: false,
    trackName: 'GridView',
  };

  listingIds(listings) {
    if (!listings) { return []; }
    return listings.map(l => l.id);
  }

  listingViews() {
    return this.props.listings.map((listingJson, index) => {
      const listing = new Listing(listingJson);
      return (
        <ListingCard
          listing={listing}
          key={listing.id}
          trackName={this.props.trackName}
          trackContext={this.props.trackContext}
          position={index}
        />
      );
    });
  }

  renderActions() {
    if (!this.props.actions) { return null; }

    return (
      <div className="listing-grid__heading__actions">
        {this.props.actions}
      </div>
    );
  }

  renderHeading() {
    if (!this.props.heading) { return null; }

    return (
      <div className="listing-grid__heading">
        <h1 className="listing-grid__heading__text">
          {this.props.heading}
        </h1>
        {this.renderActions()}
      </div>
    );
  }

  renderPagination() {
    if (!this.props.pagination) { return null; }

    return (
      <div className="listing-grid__pagination">
        {this.props.pagination}
      </div>
    );
  }

  render() {
    return (
      <section className="listing-grid">
        {this.renderHeading()}
        <Tiles
          fourWideMax
        >
          {this.listingViews()}
        </Tiles>
        {this.renderPagination()}
        {this.props.children}
      </section>
    );
  }
}
